var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtnWhatsapp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#02C66A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9050_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8536 29.7606C10.8526 33.1214 11.7376 36.403 13.4204 39.2954L10.6926 49.1778L20.8851 46.5261C23.7042 48.0489 26.8628 48.8468 30.0726 48.847H30.0811C40.6772 48.847 49.3026 40.2915 49.3072 29.7757C49.3092 24.68 47.3111 19.8884 43.6808 16.2834C40.0511 12.6788 35.2237 10.6926 30.0803 10.6902C19.4829 10.6902 10.8581 19.2453 10.8537 29.7606",
    fill: "#02C66A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1672 29.7544C10.1661 33.2361 11.0828 36.635 12.8256 39.631L10 49.8678L20.558 47.1209C23.467 48.6947 26.7423 49.5245 30.0752 49.5257H30.0837C41.06 49.5257 49.9953 40.6625 50 29.7702C50.0019 24.4915 47.9319 19.5276 44.1719 15.7935C40.4114 12.0598 35.4114 10.0022 30.0837 10C19.1056 10 10.1716 18.862 10.1672 29.7544ZM16.4547 39.115L16.0605 38.4941C14.4033 35.8795 13.5286 32.8581 13.5298 29.7557C13.5334 20.7022 20.9591 13.3364 30.09 13.3364C34.5119 13.3383 38.6675 15.0487 41.7931 18.1519C44.9186 21.2555 46.6384 25.3811 46.6373 29.769C46.6333 38.8225 39.2075 46.1891 30.0837 46.1891H30.0772C27.1064 46.1876 24.1928 45.396 21.6519 43.9L21.0472 43.5442L14.7819 45.1741L16.4547 39.1149V39.115Z",
    fill: "url(#paint0_linear_9050_318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1059 21.4958C24.7331 20.6737 24.3408 20.6571 23.9862 20.6427C23.6959 20.6302 23.3641 20.6312 23.0325 20.6312C22.7006 20.6312 22.1614 20.7551 21.7056 21.2489C21.2494 21.7431 19.9637 22.9375 19.9637 25.3668C19.9637 27.7963 21.747 30.144 21.9956 30.4738C22.2445 30.803 25.4383 35.9478 30.4964 37.927C34.7002 39.5718 35.5556 39.2447 36.468 39.1622C37.3805 39.08 39.4123 37.9681 39.8269 36.8151C40.2417 35.6622 40.2417 34.674 40.1173 34.4675C39.993 34.2617 39.6611 34.1382 39.1634 33.8913C38.6656 33.6444 36.2191 32.4498 35.763 32.285C35.3067 32.1203 34.975 32.0382 34.6431 32.5326C34.3112 33.0262 33.3583 34.1382 33.0678 34.4675C32.7777 34.7975 32.4872 34.8386 31.9897 34.5916C31.4917 34.3439 29.8891 33.8231 27.9877 32.1411C26.5083 30.8323 25.5095 29.216 25.2192 28.7216C24.9289 28.2279 25.1881 27.9603 25.4377 27.7143C25.6612 27.493 25.9355 27.1377 26.1845 26.8495C26.4327 26.5611 26.5155 26.3554 26.6814 26.0261C26.8475 25.6965 26.7644 25.4081 26.6402 25.1611C26.5155 24.9141 25.5484 22.4721 25.1059 21.4958Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9050_318",
    x1: 2010,
    y1: 3996.78,
    x2: 2010,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9050_318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnWhatsapp);
export default __webpack_public_path__ + "static/media/btn_whatsapp.77b3b9bff79129e1365b59f451d5711e.svg";
export { ForwardRef as ReactComponent };